module.exports = __webpack_public_path__ + "static/img/747x478.4d71206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/747x478.png
// module id = 3ANP
// module chunks = 0